<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">退款记录</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline" size="small">
        <el-form-item>
          <el-button type="primary" size="small" @click="submitQuery(1)">搜索</el-button>
        </el-form-item>
      </el-form>
      <hr/>
    </div>
    <el-table border :data="list" highlight-current-row>
      <el-table-column align="center" type="index"/>
      <el-table-column label="订单编号" align="center" prop="orderCode"/>
      <el-table-column label="退款类型" width="180px" align="center">
        <template slot-scope="scope">
          {{ returnTypeMap[scope.row.returnType] }}
        </template>
      </el-table-column>
      <el-table-column label="退款状态" width="180px" align="center">
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.status==='FAILURE'?'danger'
                :scope.row.status==='SUCCESS'?'success'
                :scope.row.status==='DOING'?''
                :'info'"
              effect="dark">
          {{ orderReturnStatusMap[scope.row.status] }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="发起退款时间" align="center" prop="createTime"/>
      <el-table-column label="退款理由" align="center" prop="cause"/>
      <el-table-column label="商品状态" align="center" prop="goodsStatus"/>
      <el-table-column label="退款金额" align="center" prop="orderFee"/>
    </el-table>
    <vue-pager v-bind:datafile="fillData" url="orderReturn/pageOrderReturn" v-bind:query="query"
               ref="pager" v-bind:init="true"/>
  </div>
</template>
<script>

export default {
  data() {
    return {
      query: {},
      list: [],
      orderReturnStatues: [],
      orderReturnStatusMap: {},
      returnTypes: [],
      returnTypeMap: {},
    }
  },
  created() {
    this.orderReturnStatues = this.$common.enum_config('EOrderReturnStatus');
    this.orderReturnStatues && this.orderReturnStatues.forEach((item) => {
      this.orderReturnStatusMap[item.name] = item.label
    })
    this.returnTypes = this.$common.enum_config('EReturnType');
    this.returnTypes && this.returnTypes.forEach((item) => {
      this.returnTypeMap[item.name] = item.label
    })
  },
  methods: {
    fillData(_response) {
      this.list = _response.items || [];
    },
    submitQuery(_num) {
      var _this = this;
      _this.list = [];
      _this.$refs.pager.gotoPage(_num);
    },
  },
  watch: {}
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 0 !important;
}
</style>
